<template>
  <div class="cml-submit-form">
    <h3>寻样确认</h3>
    <div v-for="item in formData" :key="item.detailId" class="form-block">
      <el-form label-width="148px" ref="formData" :model="item">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称">
              <h4>{{item.productName}}</h4>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="寻样单编号">{{item.code}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请日期">{{item.createDate}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数量">{{item.num}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="单位">{{item.unit}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="采购备注"><span style="word-break: break-all;">{{item.forSupplierRemark}}</span></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="要求到样日期">{{item.askArrivalTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="item.productType === 'RAW_MATERIAL'">
          <el-col :span="8">
            <el-form-item
              label="回复到样日期"
              :rules="[
                { required: true, message: '请选择回复到样日期', trigger: 'change' },
              ]"
              prop="actualArrivalTime"
            >
              <el-date-picker
                v-model="item.actualArrivalTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择时间"
                :picker-options="expireTimeOption"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注">
              <el-input type="textarea" style="width: 200px" v-model="item.supplierRemark" maxlength="30" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件">
              <p class="file-list-item">
                <span
                  v-for="(el, index) in item.urlList"
                  :key="index"
                >
                <el-popover
                  placement="top-start"
                  trigger="hover"
                  popper-class="popper--upload-class popper--upload-class-detail"
                  :disabled="popoverDisabled"
                  >
                    <div>
                      <el-button type="text" icon="el-icon-view" @click="previewBtn(el)">预览</el-button>
                      <el-button type="text" icon="el-icon-download" @click="downloadFile(el)">下载</el-button>
                    </div>
                    <p slot="reference">
                      <i class="el-icon-document"></i>
                      {{ el.name }}
                    </p>
                </el-popover>
                </span>
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="8">
            <el-form-item
              label="样品是否可稳定供应"
              prop="stableSupplyFlag"
              :rules="[
                { required: true, message: '请选择样品是否可稳定供应', trigger: 'change' },
              ]"
            >
            <el-radio-group v-model="item.stableSupplyFlag">
              <el-radio label="YES">是</el-radio>
              <el-radio label="NO">否</el-radio>
            </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="item.stableSupplyFlag === 'YES'">
            <el-form-item
              :rules="[
                { required: true, message: '请选择回复到样日期', trigger: 'blur' },
              ]"
              label="回复到样日期"
              prop="actualArrivalTime"
            >
              <el-date-picker
                v-model="item.actualArrivalTime"
                type="datetime"
                placeholder="选择时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="right"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="item.stableSupplyFlag === 'YES'">
            <el-form-item
              prop="supplierRemark"
              label="备注"
            >
              <el-input
                type="textarea"
                v-model="item.supplierRemark"
                maxlength="30"
                show-word-limit
                style="width: 220px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="item.stableSupplyFlag === 'NO'">
            <el-form-item
              prop="stableSupplyReason"
              label="原因说明"
              :rules="[
                { required: true, message: '请填写原因说明', trigger: 'blur' },
              ]"
            >
              <el-input
                type="textarea"
                v-model="item.stableSupplyReason"
                maxlength="30"
                show-word-limit
                style="width: 220px"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <span style="color: #AB0033; font-size: 12px; display: inline-block; margin-top: 15px">
          <i class="el-icon-warning-outline"></i>
          备注：请确认库内是否存在此样品，不存在请稍后在样品管理中上传此样品
        </span>
      </el-form>
    </div>
    <div class="submit-btn">
      <el-button type="primary" @click="confirmBtn">确认</el-button>
      <el-button @click="cancelBtn">取消</el-button>
    </div>
    <previewFileDialog :type="fileType" :url="fileUrl" ref="previewDialog" />
  </div>
</template>
<script>
import dayjs from 'dayjs';
import download from '@/utils/download';
import previewFileDialog from '@/components/previewFileDialog';

export default {
  components: {
    previewFileDialog
  },
  props: {
    formList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    fileType: '',
    fileUrl: '',
    popoverDisabled: false,
    formData: [],
    expireTimeOption:  {  //验证时间范围
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
  }),
  watch: {
    formList: {
      handler(item) {
        if(item.length < 1) return;
        return this.formData = item.map(item => {
          return {
            ...item,
            supplierRemark: '',
            actualArrivalTime: '',
            id: item.detailId
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    // 下载模板文件
    downloadFile({name, url}) {
      download(url, name);
    },
    // 预览文件
    previewBtn({name, url}) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = name.substring(name.lastIndexOf('.')).toLowerCase();
      const type = ['.png','.jpeg','.jpg'].includes(fileExtend) ? 'img' : 'file';
      this.fileUrl = url;
      this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : type;
      this.$refs.previewDialog.dialogVisible = true;
    },
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.formData.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    confirmBtn() {
      const vaild = this.checkFormValid();
      if(!vaild) return false;
      // 校验要求到样时间
      let errArr = this.formData.filter(item => dayjs(item.createDate).diff(dayjs(item.actualArrivalTime)) > 0);
      if(errArr.length > 0) {
        this.$message.error(`产品名称【${errArr[0].productName}】的回复到样时间不能早于申请时间`);
        return;
      }
      this.$http.outsideSampleManage.batchAddConfirmInfo(this.formData).then(result => {
        this.$message.success(result.msg);
        this.$emit('success');
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    cancelBtn() {
      this.$emit('cancel');
    }
  }
}
</script>